import origin from "../../originConfig.js"; // 确保路径正确
import router from "../router/index";
import store from "../store/index.js";
import http from "../http/index.js";
const messageCallbacks = new Map();

const postMessageAPI = {
  sendMessageWithCallback(message, callback) {
    const iframe = document.getElementById("h5Iframe");
    if (!iframe) {
      return;
    }
    const messageId = Math.random().toString(36).slice(-9); // 生成唯一的消息ID

    // 存储回调函数，使用 messageId 作为键
    messageCallbacks.set(messageId, callback);

    // 添加监听器以接收来自 iframe 的消息
    const listener = (event) => {
      if (event.data.messageId === messageId) {
        // 移除监听器
        window.removeEventListener("message", listener);
        // 调用回调函数，并传递消息数据
        if (typeof messageCallbacks.get(messageId) === "function") {
          messageCallbacks.get(messageId)(event.data.msg);
        }
        messageCallbacks.delete(messageId);
      }
    };

    window.addEventListener("message", listener);

    // 发送消息，并包含 messageId
    iframe.contentWindow.postMessage({ ...message, messageId }, "*");
  },
};
function formatTimestamp(timestamp) {
  // 如果输入已经是标准格式的字符串，直接返回
  if (
    typeof timestamp === "string" &&
    /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(timestamp)
  ) {
    return timestamp;
  }

  // 处理时间戳类型
  let ts = Number(timestamp);

  // 无效值处理
  if (isNaN(ts)) {
    console.warn("Invalid timestamp:", timestamp);
    return "Invalid Date";
  }

  // 时间戳单位判断（10位秒级 / 13位毫秒级）
  if (ts <= 9999999999) {
    // 秒级时间戳处理
    ts *= 1000;
  }

  // 创建日期对象
  const date = new Date(ts);

  // 验证日期有效性
  if (isNaN(date.getTime())) {
    console.error("Invalid Date from timestamp:", ts);
    return "Invalid Date";
  }

  // 提取时间组件
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // 月份从0开始计算
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  // 数字格式化函数
  const formatNumber = (n) => (n < 10 ? `0${n}` : n.toString());

  // 组装标准格式
  return (
    `${year}-${formatNumber(month)}-${formatNumber(day)} ` +
    `${formatNumber(hours)}:${formatNumber(minutes)}:${formatNumber(seconds)}`
  );
}
// 接收消息的方法
async function receiveMessage(event) {
  // console.log("event", event.data);
  const { messageId, msg, type } = event.data;
  if (type === "tcPay") {
    console.log("路由变化:", msg);
    // 通过 mutation 修改状态
    store.commit("SET_FLAG", true);
    // store.state.flag = true;
    // setTimeout(() => {
    router.push({
      path: "/pay",
      query: msg,
    });
    // }, 50);
  } else if (type === "tcLogin") {
    event.source.postMessage(
      {
        messageId,
        type,
        msg: store.state.Authorization,
      },
      event.origin
    );
  } else if (type === "tcClosePay") {
    // 这个方法取消了
    // console.log("执行了msg", msg);
    // if (msg === "success") {
    //   console.log("成功之后");
    //   store.state.flag = false;
    //   router.push("/redPacket");
    // }
  } else if (type === "tcLoginSuccess") {
    console.log("登录完成------");
    postMessageAPI.sendMessageWithCallback(
      { type: "tcGetRoleInfo" },
      async (val) => {
        if (val) {
          let obj = {};
          for (let item in val) {
            obj[item] = val[item];
          }
          obj["gameUserRegisterTime"] = formatTimestamp(
            val.gameUserRegisterTime
          );
          obj["channelId"] = store.state.channelId;
          obj["gameId"] = store.state.gameId;
          obj["deviceId"] = store.state.deviceId;
          obj["userId"] = store.state.userInfo.userId;
          await http.post("/game/game_role_info", obj);
        }
      }
    );
  } else if (type === "tcRoleSuccess") {
    console.log("创角完成------", msg);
    let obj = {};
    for (let item in msg) {
      obj[item] = msg[item];
    }
    obj["gameUserRegisterTime"] = formatTimestamp(msg.gameUserRegisterTime);
    obj["channelId"] = store.state.channelId;
    obj["gameId"] = store.state.gameId;
    obj["deviceId"] = store.state.deviceId;
    obj["userId"] = store.state.userInfo.userId;
    await http.post("/game/game_role_info", obj);
  }
}
setInterval(async () => {
  if (store.state.Authorization) {
    await http.post("/auth/refresh"); //一个小时刷新一次token 避免游戏登录过长，token过期，但是游戏还在。
  }
}, 60 * 60 * 1000); // 1小时
// 添加全局监听器以接收消息
window.addEventListener("message", receiveMessage);
export default postMessageAPI;
